module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "structure"
    }
  }, [_c('p', {
    staticClass: "sert",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "50",
      "src": "images/logo-3ct.jpg",
      "width": "45"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sert",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _vm._v("Chicago Studies in Practices of Meaning")]), _vm._v(" "), _c('p', {
    staticClass: "serah",
    staticStyle: {
      "font-style": "normal",
      "font-weight": "bold"
    }
  }, [_vm._v("A series edited by Andreas Glaeser, William Mazzarella, William H. Sewell Jr., Kaushik Sunder Rajan, and Lisa Wedeen")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Published in collaboration with the Chicago Center for Contemporary Theory")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://ccct.uchicago.edu",
      "target": "_blank"
    }
  }, [_vm._v("http://ccct.uchicago.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "serah"
  }, [_vm._v("Recent books in the series")]), _vm._v(" "), _c('p', {
    staticClass: "seraft"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("WHAT")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("NOSTALGIA")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WAS:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WAR,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EMPIRE,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TIME")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DEADLY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EMOTION")]), _vm._v(" by Thomas Dodman")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MANA")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MASS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SOCIETY")]), _vm._v(" by William Mazzarella")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SINS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FATHER:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("GERMANY,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MEMORY,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("METHOD")]), _vm._v(" by Jeffrey K. Olick")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("POLITICS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DIALOGIC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IMAGINATION:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("POWER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("POPULAR")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CULTURE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EARLY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MODERN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("JAPAN")]), _vm._v(" by Katsuya Hirano")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("AMERICAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("VALUE:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MIGRANTS,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MONEY,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MEANING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SALVADOR")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("UNITED")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("STATES")]), _vm._v(" by David Pedersen")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("QUESTIONING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SECULARISM:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISLAM,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SOVEREIGNTY,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RULE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LAW")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MODERN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EGYPT")]), _vm._v(" by Hussein Ali Agrama")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MAKING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ROMANTIC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LOVE:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LONGING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SEXUALITY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EUROPE,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SOUTH")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ASIA,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("JAPAN,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("900–1200")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CE")]), _vm._v(" by William M. Reddy")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MORAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("NEOLIBERAL:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WELFARE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CITIZENSHIP")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ITALY")]), _vm._v(" by Andrea Muehlebach")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("GENEALOGICAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SCIENCE:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SEARCH")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("JEWISH")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ORIGINS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("POLITICS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EPISTEMOLOGY")]), _vm._v(" by Nadia Abu El-Haj")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("LAUGHING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AT")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LEVIATHAN:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SOVEREIGNTY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AUDIENCE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WEST")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PAPUA")]), _vm._v(" by Danilyn Rutherford")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d781d5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-fattal-0003.vue
// module id = 60
// module chunks = 0